<template>
  <nav class="footer-menu__nav footer-nav">
    <div class="footer-nav__section">
      <header class="footer-nav__header" @click="toggleListHidden('about')">
        <p class="footer-nav__title">{{ $t('down.menu.information') }}</p>
        <button
          class="footer-nav__arrow"
          aria-label=""
          :class="{ 'footer-nav__arrow--rotate': !hiddenLists.about }"
        ></button>
      </header>
      <ul class="footer-nav__list" :class="{ 'footer-nav__list--hidden': hiddenLists.about }">
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/shops/'">{{
            $t('up.menu.stores')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/comments/'">{{
              $t('down.menu.comments')
            }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/blog/'">{{ $t('down.menu.blog') }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/news/'">{{ $t('down.menu.news') }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/career/'">{{ $t('down.menu.job') }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/regulamin-sklepu-internetowego/'">{{
            $t('down.menu.regulations')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/terms-and-conditions/'">{{
            $t('down.menu.policy')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/cookies-policy/'">{{
            $t('down.menu.cookies')
          }}</a>
        </li>
        <li class="footer-nav__item" v-if="isBonusServiceActive">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/loyalty-program/'">{{
            $t('down.menu.loyalty.program')
          }}</a>
        </li>
      </ul>
    </div>
    <div class="footer-nav__section">
      <header class="footer-nav__header" @click="toggleListHidden('help')">
        <p class="footer-nav__title">{{ $t('down.menu.help') }}</p>
        <button
          class="footer-nav__arrow"
          aria-label=""
          :class="{ 'footer-nav__arrow--rotate': !hiddenLists.help }"
        ></button>
      </header>
      <ul class="footer-nav__list" :class="{ 'footer-nav__list--hidden': hiddenLists.help }">
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/contact/'">{{
            $t('down.menu.contacts')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/dostavka-i-oplata/'">{{
            $t('down.menu.delivery.and.payment')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/dostavka-i-oplata/#return-goods'">{{
            $t('down.menu.return.goods')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/garantia-i-servisu/'">{{
            $t('down.menu.repair.and.warranty')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/reklamacje-i-skargi/'">{{
            $t('down.menu.claims')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/?cmpscreen '">{{
            $t('down.menu.consent')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/site/sitemap/'">{{
              $t('down.menu.sitemap')
            }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/faq/'">{{
            $t('down.menu.faq')
          }}</a>
        </li>
      </ul>
    </div>
    <div class="footer-nav__section">
      <header class="footer-nav__header" @click="toggleListHidden('services')">
        <p class="footer-nav__title">{{ $t('down.menu.offers') }}</p>
        <button
          class="footer-nav__arrow"
          aria-label=""
          :class="{ 'footer-nav__arrow--rotate': !hiddenLists.services }"
        ></button>
      </header>
      <ul class="footer-nav__list" :class="{ 'footer-nav__list--hidden': hiddenLists.services }">
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/sale/'">{{
            $t('up.menu.shares')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/outlet/'">{{
              $t('up.menu.outlet')
            }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link footer-nav__item-link--inverse" :href="urlLanguagePrefix + '/black-friday/'">{{
              $t('down.menu.black-week')
            }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/novynky/'">{{
            $t('down.menu.novelty')
          }}</a>
        </li>
        <li class="footer-nav__item">
          <a class="footer-nav__item-link" :href="urlLanguagePrefix + '/dystrybucja/'">{{
            $t('up.menu.distribution')
          }}</a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'FooterNav',
  data () {
    return {
      hiddenLists: {
        about: true,
        help: true,
        services: true
      }
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      config: state => state.init.config
    }),
    isBonusServiceActive () {
      return this.config.service?.is_bonus_service_active
    }
  },
  methods: {
    toggleListHidden (list) {
      this.hiddenLists[list] = !this.hiddenLists[list]
    }
  }
}
</script>

<style scoped lang="sass">

.footer-menu__nav
  display: flex
  flex-flow: row nowrap
  justify-content: space-between

  +mmax(768)
    flex-flow: column

.footer-nav__section
  width: calc(100% / 3)

  +mmax(768)
    width: 100%
    border-bottom: 1px solid #494949
    overflow: hidden

.footer-nav__header
  display: flex
  justify-content: space-between

  +mmax(768)
    padding: 20px 10px

.footer-nav__arrow
  display: none
  border: 0
  background-color: transparent
  background-image: url('/img/svgo/footer/menu-arrow.svg')
  background-position: center
  background-repeat: no-repeat
  transition: ease-in-out .4s

  +mmax(768)
    display: block

  &--rotate
    transform: rotate(180deg)

.footer-nav__title
  font-weight: 400
  font-size: 14px
  letter-spacing: .05em
  text-transform: uppercase
  color: $placeholder-color
  margin: 0

.footer-nav__list
  margin: 20px 0 0
  padding: 0
  list-style: none
  max-height: 300px
  transition: ease-in-out .4s

  +mmax(768)
    margin: 0 0 20px
    padding: 0 10px

  &--hidden
    +mmax(768)
      margin: 0
      max-height: 0

.footer-nav__item
  font-weight: 400
  font-size: 14px
  line-height: 17px

  &:not(:last-child)
    margin-bottom: 16px

.footer-nav__item-link
  color: $white-text-color
  transition: .2s

  &:hover
    color: darken($white-text-color, 15%)
    text-decoration: none
  &--inverse
    color: #ff2f00
    &:hover
      color: #ff2f00
</style>
